function getDataTestId(componentName, displayType, uniqueId) {
  return `${componentName}${displayType ? `_${displayType}` : ""}${uniqueId ? `_${uniqueId}` : ""}`;
}
const listMissingVariables = (variables) => {
  const missing = [];
  for (const name in variables) {
    if (variables[name] === void 0) {
      missing.push(name);
    }
  }
  return missing.join(", ");
};
export {
  getDataTestId,
  listMissingVariables
};
